// const API_DOMAIN = 'http://10.61.185.113:8082/vmp/'
// const API_RECORDINGS = 'http://10.61.185.113:8082/vmp/'
// const API_DOMAIN = "https://ops.viettelmeet.com/vmp/";

import { env } from "utils/helpers";

/***************************************************************
 * MOBILE VERSION
 ***************************************************************/
// const MOBILE_BUILD_VERSION = "3.3.1" 
const MOBILE_BUILD_VERSION = env('REACT_APP_MOBILE_BUILD_VERSION') || "3.3.1.fallback"


/***************************************************************
 * TEST ENVIROMENT
 ***************************************************************/
// const API_RECORDINGS = "https://meeting.atviettelsolutions.com/vmp/";
// const DOMAIN_MEETING = "https://testmeeting.atviettelsolutions.com";
// const API_DOMAIN = "https://ops.viettelmeet.com/vmp/";
// const SOCKET_URL = 'https://ops.viettelmeet.com';
// const API_DOMAIN_SSO = "https://ops.viettelmeet.com/";
// const PAGE_DOMAIN = "https://ops.viettelmeet.com/" ;
// export const PAGE_WHITEBOARD = "https://testboard.atviettelsolutions.com/boards/";
// export const WHITEBOARDS_DOMAIN = 'https://ops.viettelmeet.com/api/whiteboard/v1.0/';
// export const COOKIES_TOKEN_KEY = 'vmp_token_test';
// export const COOKIES_REFRESH_TOKEN_KEY = env('REACT_APP_COOKIES_REFRESH_TOKEN_KEY') || 'vmp_refresh_token_test';
// export const URL_ANDROID = env('REACT_APP_URL_ANDROID') || "https://ops.viettelmeet.com/download/mobile/android/vt-meeting.apk";
// export const URL_IOS = env('REACT_APP_URL_IOS') || "https://appbox.me/fy4nln59";
// export const URL_LANDING_PAGE = env('REACT_APP_URL_LANDING_PAGE') || "https://viettelmeetingtest.atviettelsolutions.com";
// export const URL_POLICY = env('REACT_DOMAIN_POLICY') || "https://viettelmeeting.atviettelsolutions.com/documents/204/dieu-khoan-chinh-sach";

/***************************************************************
 * PRODUCT ENVIROMENT
***************************************************************/
// const API_RECORDINGS = "https://meeting.atviettelsolutions.com/vmp/";
// const DOMAIN_MEETING = "https://meeting.atviettelsolutions.com";
// const API_DOMAIN = "https://authvmp.atviettelsolutions.com/vmp/";
// const SOCKET_URL = 'https://authvmp.atviettelsolutions.com';
// const API_DOMAIN_SSO = "https://authvmp.atviettelsolutions.com/";
// const PAGE_DOMAIN = "https://authvmp.atviettelsolutions.com/" ;
// export const PAGE_WHITEBOARD = "https://board.atviettelsolutions.com/boards/";
// export const WHITEBOARDS_DOMAIN = 'https://authvmp.atviettelsolutions.com/api/whiteboard/v1.0/';
// export const COOKIES_TOKEN_KEY = 'vmp_token';
// ***********************************************

/***************************************************************
 * LOCAL ENVIROMENT
 ***************************************************************/
// const API_DOMAIN = 'http://10.61.185.93:8089/vmp/';
// const SOCKET_URL = 'http://10.61.185.93:8089';
// const API_DOMAIN_SSO = 'http://10.61.185.93:8089/vmp/'
// const DOMAIN_MEETING = "https://testmeeting.atviettelsolutions.com";
// export const WHITEBOARDS_DOMAIN = 'http://10.61.185.93:6001/v1.0/';
// export const PAGE_WHITEBOARD = "https://authboard.atviettelsolutions.com/boards/";
// const API_RECORDINGS = "https://meet.viettelmeet.com/vmp/";
// const PAGE_DOMAIN = "http://localhost:3001/"
// export const COOKIES_TOKEN_KEY = 'vmp_token_test';
// export const COOKIES_REFRESH_TOKEN_KEY = env('REACT_APP_COOKIES_REFRESH_TOKEN_KEY') || 'vmp_refresh_token_test';
// export const URL_ANDROID = env('REACT_APP_URL_ANDROID') || "https://ops.viettelmeet.com/download/mobile/android/vt-meeting.apk";
// export const URL_IOS = env('REACT_APP_URL_IOS') || "https://appbox.me/fy4nln59";
// export const URL_LANDING_PAGE = env('REACT_APP_URL_LANDING_PAGE') || "https://viettelmeetingtest.atviettelsolutions.com";
// export const URL_POLICY = env('REACT_DOMAIN_POLICY') || "https://viettelmeeting.atviettelsolutions.com/documents/204/dieu-khoan-chinh-sach";



// ***********************************************

const PATH_ROOT = env('PATH_ROOT') || "";
// const API_RECORDINGS = env('REACT_APP_API_RECORDINGS') || "https://meet.viettelmeet.com/vmp/";
const DOMAIN_MEETING = env('REACT_APP_DOMAIN_MEETING') || "https://testmeeting.atviettelsolutions.com";
const API_DOMAIN = env('REACT_APP_API_DOMAIN') || "https://ops171.vmptest.com/vmp/";
const SOCKET_URL = env('REACT_APP_SOCKET_URL') || 'https://ops.viettelmeet.com/vmp';
const API_DOMAIN_SSO = env('REACT_APP_API_DOMAIN_SSO') || "https://ops.viettelmeet.com/";
const API_DOMAIN_DOWNLOAD = env('REACT_APP_API_DOMAIN_DOWNLOAD') || "https://ops171.vmptest.com/";
export const PAGE_DOMAIN = env('REACT_APP_PAGE_DOMAIN') || "https://ops.viettelmeet.com/";
export const DOMAIN_DESKTOP_DOWNLOAD = `${env('REACT_APP_PAGE_DOMAIN')}vmp/`;
export const PAGE_WHITEBOARD = env('REACT_APP_PAGE_WHITEBOARD') || "https://testboard.atviettelsolutions.com/boards/";
export const WHITEBOARDS_DOMAIN = env('REACT_APP_WHITEBOARDS_DOMAIN') || 'https://ops.viettelmeet.com/api/whiteboard/v1.0/';
export const COOKIES_TOKEN_KEY = env('REACT_APP_COOKIES_TOKEN_KEY') || 'vmp_token_test171';
export const COOKIES_REFRESH_TOKEN_KEY = env('REACT_APP_COOKIES_REFRESH_TOKEN_KEY') || 'vmp_refresh_token_test171';
export const URL_LANDING_PAGE = env('REACT_APP_URL_LANDING_PAGE') || "https://home.atviettelsolutions.com";
export const URL_IOS = env('REACT_APP_URL_IOS') || "https://appbox.me/fy4nln59";
export const URL_ANDROID = env('REACT_APP_URL_ANDROID') || "https://authmeet.atviettelsolutions.com/download/mobile/android/vt-meeting.apk";
export const URL_POLICY = env('REACT_DOMAIN_POLICY') || "https://document.viettelmeet.com/documents/435/dieu-khoan-su-dung-dich-vu-va-chinh-sach-bao-ve-du-lieu-ca-nhan";
export const VTCLOUD_IAM_URL = env('REACT_APP_VTCLOUD_IAM_URL') || "https://iam.viettelcloud.vn";
export const VTCLOUD_CLIENT_ID = env('REACT_APP_VTCLOUD_CLIENT_ID') || "vmp";
export const VTCLOUD_MARKETPLACE = env('REACT_APP_VTCLOUD_MARKETPLACE') || "https://console.viettelcloud.vn/en/marketplace/products";
export const CLIENT_ID_GOOGLE_SSO = env('REACT_APP_CLIENT_ID_GOOGLE_SSO');
export const API_DOMAIN_RECORDING = env("REACT_APP_API_DOMAIN_RECORDING") || "https://ops.viettelmeet.com/api/recording-service/v2.0"
export const VT_POLICY = env("REACT_APP_VT_POLICY") || "https://document.viettelmeet.com/documents/435/dieu-khoan-su-dung-dich-vu-va-chinh-sach-bao-ve-du-lieu-ca-nhan"

export const SME_URL = env("SME_URL") || 'http://10.207.252.223'
export const SME_CLIENT_ID = env("SME_CLIENT_ID") || 'vme'
export const CLIENT_ID_CLOUD = env('REACT_APP_CLIENT_ID_CLOUD') || env('REACT_APP_CLIENT_ID_GOOGLE_SSO')

export const API_MCU = env('REACT_APP_API_MCU') || "https://ops171.vmptest.com/api/mcu-control/v1.0";

const API_MAP = {
  CHECK_LIMIT_MEETING: API_DOMAIN + "v1.2/rooms/check-limit-meeting",
  GET_TOTAL_MEETING: API_DOMAIN + "v1.2/rooms/total-meeting-progress",
  GET_PACKAGES: API_DOMAIN + "license-management/get-my-license-packages",
  GET_PACKAGE_DETAIL: API_DOMAIN + "license-management/get-my-license-product-packages",
  RESPONSE_INVITE_LICENSE: API_DOMAIN + "license-management/response-invite-license",
  INVITE_USER_ASSIGN: API_DOMAIN + "license-management/invite-user-assigned-license",
  GET_MY_USER_LICENSE: API_DOMAIN + "license-management/get-my-users-license",
  GET_MY_INVITE_LICENSE: API_DOMAIN + "license-management/get-my-invite-license",
  GET_MY_CURRENT_LICENSE: API_DOMAIN + "license-management/get-my-license",
  UNASSIGN_LICENSE: API_DOMAIN + "license-management/remove-license",
  TEMPLATE_SIP_ACC: API_DOMAIN_DOWNLOAD + "download/template/template_sip_account.xlsx",
  TEMPLATE_ACC: API_DOMAIN_DOWNLOAD + "download/template/template_account.xlsx",
  CHECK_USER_BLOCK: API_DOMAIN + "check-user-block",
  CHECK_REFRESH_TOKEN: API_DOMAIN + "auth/refresh",
  VERIFY_GOOGLE: API_DOMAIN + "sso",
  REGISTER_SSO: API_DOMAIN + "sso/register",
  REGISTER_SSO_LINK_ACCOUNT: API_DOMAIN + "sso/register-link-account",
  ADMIN_RESET_PASSWORD: API_DOMAIN + "reset-password",
  SEND_MAIL_VERIFY: API_DOMAIN + "sendEmailVerify",
  USER: {
    // UPDATE_USER: API_DOMAIN + "update-profile",
    UPDATE_USER: API_DOMAIN + "update-info-profile",
    REMOVE_AVATAR: API_DOMAIN + "remove-avatar"
  },
  DOWNLOAD_MOBILE_APP: API_DOMAIN + "mobile-app",
  LOGIN: API_DOMAIN + "login",
  REGISTER: API_DOMAIN + "register",
  SSO: API_DOMAIN_SSO + "auth/oauth2",
  Facebook: API_DOMAIN_SSO + "auth/facebook",
  Icloud: API_DOMAIN_SSO + "auth/icloud",
  Google: API_DOMAIN_SSO + "auth/google",
  GET_USER_BY_TOKEN: API_DOMAIN + "get-user-token",
  GET_USER_BY_Id: API_DOMAIN + "account",
  GET_LIST_USER: API_DOMAIN + "find-account",
  CREAT_USER: API_DOMAIN + "create-account",
  UPDATE_ACCOUNT: API_DOMAIN + "update-status-account",
  UPDATE_USER: API_DOMAIN + "update-account",
  UPDATE_USER_WITH_ADMIN: API_DOMAIN + "admin-update-account",
  DELETE_USER: API_DOMAIN + "delete-account",
  GET_ALL_ROLE: API_DOMAIN + "action/group-role",
  GET_SYSTEM_ROLES: API_DOMAIN + "roles",
  GET_LIST_ROLE: API_DOMAIN + "action/find-group-role",
  GET_ROLE_BY_ID: API_DOMAIN + "action/group-role",
  UPDATE_ROLE: API_DOMAIN + "action/update-group-role",
  CREATE_ROLE: API_DOMAIN + "action/add-group-role",
  DELETE_ROLE: API_DOMAIN + "action/delete-group-role",
  GET_LIST_FUNCTION_BY_GROUP_ID: API_DOMAIN + "action/group",
  GET_LIST_FUNCTION: API_DOMAIN + "action/role",
  UPDATE_LIST_FUNCTION: API_DOMAIN + "action/update-group",
  GET_LIST_HISTORY_ROOM: API_DOMAIN + "rooms/history",
  GET_LIST_ROOMS: API_DOMAIN + "rooms/byType",
  GET_HISTORY: API_DOMAIN + "rooms/byType/history",
  JOIN_NOW: API_DOMAIN + "rooms/event/room-now",
  STATUS_MEETING: API_DOMAIN + "rooms/event/inviteeStatus",
  INFO_INVITEESTATUS: API_DOMAIN + "rooms/getInfo/inviteeStatus",
  // GET_ROOM: API_DOMAIN + "rooms",
  GET_ROOM: API_DOMAIN + "v1.1/rooms",
  CREATE_ROOM: API_DOMAIN + "v1.1/rooms/create",
  UPLOAD_FILE: API_DOMAIN + "files/upload?roomId=",
  UPLOAD_FILE_MEETING: API_DOMAIN + "v1.2/files/upload?is_create=1&slot=",
  UPLOAD_AVATAR: API_DOMAIN + "files/avatar",
  UPLOAD_EXCEL: API_DOMAIN + "files/uploadExcel",
  UPLOAD_EXCEL_ACCOUNT: API_DOMAIN + "files/uploadExcelAccount",
  GET_FILES: API_DOMAIN + "files/",
  DOWNLOAD_FILE: API_DOMAIN + "files/download/",
  DOWNLOADS_ALL_FILE: API_DOMAIN + "files/downloads/",
  DELETE_FILE: API_DOMAIN + "files/delete",
  DELETE_FILE_WHEN_CREATE: API_DOMAIN + "v1.2/files/delete",
  SEARCH_USER: API_DOMAIN + "search-users-room",
  UPDATE_ROOM: API_DOMAIN + "v1.1/rooms/update",
  CANCEL_ROOM: API_DOMAIN + "v1.1/rooms/cancel",
  RESTORE_ROOM: API_DOMAIN + "v1.1/rooms/restore",
  DELETE_ROOM: API_DOMAIN + "v1.1/rooms/delete",
  // Notification api
  ALL_NOTIFICATION: API_DOMAIN + "notification/get-all",
  UPDATE_NOTIFICATION_STATUS: API_DOMAIN + "notification/noti-status",
  UPDATE_ALL_NOTIFICATION_STATUS: API_DOMAIN + "notification/all-noti-status",
  CHECK_USER_STILL_IN_ROOM: API_DOMAIN + "notification/check-user-in-room",
  // Room api
  UPDATE_STATUS_ROOM: API_DOMAIN + "rooms/status/update",
  UPDATE_END_ROOM: API_DOMAIN + "rooms/event/end-room",
  LOGOUT: API_DOMAIN + "auth/logout",
  GET_ONE_CONFIG: API_DOMAIN + "config-systems/get-one-config",
  GET_CONFIG: API_DOMAIN + "config-systems/get-list-config",
  CREATE_CONFIG: API_DOMAIN + "config-systems/create-config",
  UPDATE_CONFIG: API_DOMAIN + "config-systems/update-config",
  DELETE_CONFIG: API_DOMAIN + "config-systems/delete-list-config",
  GET_ROLE_BY_TOKEN: API_DOMAIN + "action/group-role-token",
  GET_LOGIN_INFO: API_DOMAIN + "checkLoginInfo",
  CHECK_TYPE_ROOM: API_DOMAIN + "v1.1/rooms/checkTypeRoom",
  CHANGE_PASSWORD: API_DOMAIN + "update-password",
  CHANGE_PASSWORD_BY_TOKEN: API_DOMAIN + "update-password-by-token",
  FORGOT_PASSWORD: API_DOMAIN + "forgot-password",
  RESET_PASSWORD: API_DOMAIN + "reset-password",
  UPDATE_WITHOUT_PASSWORD: API_DOMAIN + "update-without-password",
  GET_ALL_RECORDINGS_BY_USER: API_DOMAIN_RECORDING + "/users/",
  GET_ALL_RECORDINGS_BY_ZOOM: `${API_DOMAIN_RECORDING}/meetings`,
  GET_DETAIL_RECORD: `${API_DOMAIN_RECORDING}/get-record-detail`,
  PLAY_BACK_RECORD: `${API_DOMAIN_RECORDING}/playback`,
  DOWNLOAD_MY_RECORD: `${API_DOMAIN_RECORDING}/download-my-record`,
  DELETE_RECORDING: `${API_DOMAIN_RECORDING}/meetings`,
  DELETE_BACK_RECORDING: `${API_DOMAIN_RECORDING}/recordings/v1.0/delete`,
  DELETE_ROOM_RECORDING: `${API_DOMAIN_RECORDING}/users`,
  GET_MY_RECORD_DETAIL: `${API_DOMAIN_RECORDING}/get-my-record-detail`,
  DELETE_ONE_RECORD: `${API_DOMAIN_RECORDING}/delete-my-record`,
  GET_LIST_BACKUP: API_DOMAIN + "backup/get-list-backup",
  GET_BACKUP_BY_ID: API_DOMAIN + "backup/get-backup-by-id",
  CREATE_BACKUP: API_DOMAIN + "backup/create-backup",
  UPDATE_BACKUP: API_DOMAIN + "backup/update-backup",
  DELETE_BACKUP: API_DOMAIN + "backup/delete-backup",
  GET_HISTORY_SYSTEM: API_DOMAIN + "history-system/get-history",
  UPDATE_HISTORY_SYSTEM: API_DOMAIN + "history-system/update-history",
  GET_CAPTCHA_REGISTER: API_DOMAIN + "getCaptchaRegister",
  GET_HISTORY_LOGIN: API_DOMAIN + "history-login/get-history",
  GET_MY_HISTORY_LOGIN: API_DOMAIN + "history-login/get-my-history",
  GET_HISTORY_ACTION: API_DOMAIN + "action-log/get",
  GET_ERROR_LOG: API_DOMAIN + "error-log/get",
  DOMAIN_MEETING: DOMAIN_MEETING,
  ROOM_API: {
    GET_ROOM_BY_TIME: API_DOMAIN + "v1.1/rooms/getRooms/time",
    GET_DETAIL_STATISTICS_ROOM: API_DOMAIN + "rooms/get-detail/attendance",
    DOWNLOAD_DETAIL_STATISTICS: API_DOMAIN + "rooms/get-detail/download",
    GET_LIST_PROGRESS_ROOM: API_DOMAIN + "v1.1/list-progress-room"
  },
  MANAGER_USERS_SIP: {
    SEARCH: API_DOMAIN + "sip/get-account",
    CREATE: API_DOMAIN + "sip/add-account",
    GET_BY_ID: API_DOMAIN + "sip/get-account-byId?id=",
    UPDATE: API_DOMAIN + "sip/update-account",
    DELETE: API_DOMAIN + "sip/delete-account",
    UPDATE_STATUS: API_DOMAIN + "sip/update-status"
  },
  SYSTEM_MONITOR: {
    GET_USER_IN_ROOM: API_DOMAIN + "v1.1/get-users-in-room/",
    ENDPOINT_STATS: API_DOMAIN + "endpoint-stats"
  },
  AUTH: {
    REFRESH_TOKEN: API_DOMAIN + "auth/refresh",
    ENABLE_2FA: API_DOMAIN + "auth/2fa/enable",
    VERIFY_ENABLE_2FA: API_DOMAIN + "auth/2fa/verify-enable",
    DISABLE_2FA: API_DOMAIN + "auth/2fa/disable",
    REJECT_2FA: API_DOMAIN + "auth/2fa/reject",
    CURRENT_2FA: API_DOMAIN + "auth/2fa/current-status",
    REQUIRED_ROLE_2FA: API_DOMAIN + "auth/2fa/required-role",
    VERIFY_LOGIN_2FA: API_DOMAIN + "auth/2fa/verify-login"
  },
  SEND_OTP: API_DOMAIN + "sendOtp",
  VERIFY_OTP: API_DOMAIN + "verifyOtp",
  CHECK_EMAIL: API_DOMAIN + 'checkEmail',
  CHECK_PASSWORD: API_DOMAIN + 'checkPassword',
  LINK_ACCOUNT_SSO: API_DOMAIN + 'linkAccountSSO',
  CHECK_REGISTER_BY_EMAIL: API_DOMAIN + "sso/check-register-by-email",
  VERIFY_MAIL: API_DOMAIN + 'verifyMail',
  GET_LIST_SUB: API_DOMAIN + 'live-captions/get-info',
  LOCK_OR_UNLOCK: API_DOMAIN + 'live-captions/lock',
  MOVE_TO_TRASH_SUB: API_DOMAIN + 'live-captions/move',
  DELETE_FOREVER_SUB: API_DOMAIN + 'live-captions/delete',
  DELETE_ALL_FOREVER_SUB: API_DOMAIN + "live-captions/deleteAll",
  GET_SHARED_LIST_PEOPLE_BY_ID: API_DOMAIN + 'live-captions/shared-list-by-id',
  SHARE_PEOPLE_LIVE_CAPTIONS: API_DOMAIN + 'live-captions/share',
  UNSHARE_PEOPLE_LIVE_CAPTIONS: API_DOMAIN + 'live-captions/unshare',
  VIEW_DETAIL_SUB: API_DOMAIN + 'live-captions/read-json-file',
  EXPORT_FILE_SUB: API_DOMAIN + 'live-captions/export/',
  EXPORT_FILE_SUMMARY: API_DOMAIN + 'live-captions/export-summary',
  GET_LIST_FUNCTIONS: API_DOMAIN + 'functions',
  ADD_FUNCTION: API_DOMAIN + 'functions',
  GET_ONE_FUNCTION: API_DOMAIN + 'functions',
  UPDATE_FUNCTION: API_DOMAIN + 'functions/update',
  GET_LIST_ROLES: API_DOMAIN + 'roles',
  ADD_ROLE: API_DOMAIN + 'roles',
  GET_ROLE: API_DOMAIN + 'roles',
  EDIT_ROLE: API_DOMAIN + 'roles/update',
  GET_LIST_ROLE_FUNCTIONS: API_DOMAIN + 'roles',
  DELETE_ROLES: API_DOMAIN + 'roles/delete',
  GET_USER_FUNCTIONS: API_DOMAIN + 'functions/get/user-functions',
  UPDATE_SUMMARY_SUB: API_DOMAIN + 'live-captions/update-json-file',

  //landingPage
  GET_LIST_EVENT: API_DOMAIN + 'files/get-events-info',
  GET_LIST_EVENT_ADMIN_ACTIVE: API_DOMAIN + 'files/get-event-active/admin',
  GET_DETAIL_EVENT: API_DOMAIN + 'files/get-detail-event',
  CREATE_EVENT: API_DOMAIN + 'files/eventImage',
  UPDATE_EVENT: API_DOMAIN + 'files/update-event',
  DELETE_EVENT: API_DOMAIN + 'files/delete-event',
  UPDATE_STATUS_EVENT: API_DOMAIN + 'files/update-status-event',
  CAPACITY: {
    GET_USER_CAPACITY: API_DOMAIN_RECORDING + '/get-user-capacity',
    GET_USER_SHARED_STORAGE: API_DOMAIN_RECORDING + '/get-user-shared-storage'
  },
  RECORDING: {
    GET_MY_RECORD_DETAIL: API_DOMAIN_RECORDING + '/get-my-record-detail',
    GET_SHARED_USER_LIST: API_DOMAIN_RECORDING + '/get-shared-user-list',
    SHARE_RECORD: API_DOMAIN_RECORDING + '/share-record',
    UNSHARE_RECORD: API_DOMAIN_RECORDING + '/unshare-record',
    UPDATE_SHARING_PERMISSION: API_DOMAIN_RECORDING + '/update-sharing-permission',
    UPDATE_SHARING_GROUP_PERMISSION: API_DOMAIN_RECORDING + '/update-sharing-group-permission',
    DELETE_RECORD: API_DOMAIN_RECORDING + '/delete-my-record',
    DOWNLOAD_RECORD: API_DOMAIN_RECORDING + '/download-my-record',
    DELETE_RECORD_IDS: API_DOMAIN_RECORDING + '/delete-records'
  },

  //manager-storage
  GET_PARTICIPANTS_SHARED_STORAGE: API_DOMAIN_RECORDING + '/get-participants-shared-storage',
  INVITE_USING_SHARED_STORAGE: API_DOMAIN_RECORDING + '/invite-using-shared-storage',
  GET_LIST_INVITATIONS: API_DOMAIN_RECORDING + '/get-list-invitations',
  RESPONSE_INVITATION: API_DOMAIN_RECORDING + '/response-invitation',
  RETRIEVE_INVITATION: API_DOMAIN_RECORDING + '/retrieve-invitation',
  GET_STATISTIC_STORAGE: API_DOMAIN_RECORDING + '/get-statistic-storage',

  PHONEBOOK: {
    GET: API_DOMAIN + 'contacts/v1.0/get-contacts',
    CREATE: API_DOMAIN + 'contacts/v1.0/create',
    UPDATE: API_DOMAIN + 'contacts/v1.0/update/',
    DELETES: API_DOMAIN + 'contacts/v1.0/delete?ids='
  },
  SYSTEM: {
    GET_CONFIGS: API_DOMAIN + 'config-systems/get-configs',
    CHANGE_ADMIN_PORT: API_DOMAIN + 'config-systems/change-port-web-admin',
    UNIT: {
      GET_LIST: API_DOMAIN + 'unit/v1.0/list',
      FULL_TREE: API_DOMAIN + 'unit/v1.0/full-tree',
      TREE: API_DOMAIN + 'unit/v1.0/tree',
      USER: API_DOMAIN + 'unit/v1.0',
      GET_POSITION: API_DOMAIN + 'unit/v1.0/positions/list',
      DELETE_UNIT: API_DOMAIN + 'unit/v1.0/delete',
      ADD_UNIT: API_DOMAIN + 'unit/v1.0/add',
      EDIT_UNIT: API_DOMAIN + 'unit/v1.0/update'
    }
  },
  APP_VERSION: {
    UPLOAD: API_DOMAIN + 'app/versions/upload/file',
    GET_ALL: API_DOMAIN + 'app/versions',
    CREATE: API_DOMAIN + 'app/versions',
    UPDATE: API_DOMAIN + 'app/versions',
    GET: API_DOMAIN + 'app/versions',
    DELETE: API_DOMAIN + 'app/versions/delete',
    RELEASE: API_DOMAIN + 'app/versions/'
  },
  SHARING_INFO: {
    UPDATE_STATUS: API_DOMAIN + 'personal-info/share'
  },
  WHITE_LABEL: {
    GET_INFO: API_DOMAIN + 'whitelabel',
    UPLOAD_BACKGROUND_IMAGE: API_DOMAIN + `whitelabel/update/manager_background_image/image`,
    UPDATE: API_DOMAIN + 'whitelabel',
    REMOVE_BACKGROUND: `${API_DOMAIN}whitelabel/backgrounds/delete`
  },
  MCU: {
    GET_LIST_ROOM: API_MCU + '/conference/list',
    CREATE_ROOM: API_MCU + '/conference/create',
    UDPATE_ROOM: API_MCU + '/conference/update',
    DELETE_ROOM: API_MCU + '/conference/disable',
    CONTROL_PARTICIPANT_ROOM: API_MCU + '/conference-control',
    MONITOR_ROOM: API_MCU + '/conference-monitor',
    ROOMS: API_MCU + "/rooms",
    LAYOUTS: API_MCU + "/layouts",
    MONITOR: {
      GET_LIST_ROOM: API_MCU + '/conference-monitor/list',
      GET_ROOM_INFO: API_MCU + '/conference-monitor'
    },
    SIP: {
      GET_LIST_ACCOUNT: API_MCU + '/sip-account/list',
      UPDATE_ACCOUNT: API_MCU + '/sip-account/update',
      CREATE_ACCOUNT: API_MCU + '/sip-account/create',
      DELETE_ACCOUNT: API_MCU + '/sip-account/delete'
    },
    DEVICES: {
      GET_LIST: API_MCU + '/device/list',
      DELETE_DEVICE: API_MCU + '/device/delete',
      CREATE_DEVICE: API_MCU + '/device/create',
      UPDATE_DEVICE: API_MCU + '/device/update'
    }
  },
  GROUPS: {
    GETS: API_DOMAIN + 'user-group/v1.0/list',
    GET: API_DOMAIN + 'user-group/v1.0/detail/',
    MEMBER_LIST: API_DOMAIN + 'user-group/v1.0/member/list',
    ADD_GROUP: API_DOMAIN + 'user-group/v1.0/add',
    ADD_MEMBER: API_DOMAIN + 'user-group/v1.0/member/add',
    REMOVE_GROUP: API_DOMAIN + 'user-group/v1.0/delete/',
    REMOVE_MEMBER: API_DOMAIN + 'user-group/v1.0/member/remove',
    UPDATE_GROUP: API_DOMAIN + 'user-group/v1.0/update/'
  },
  ROLES: {
    GET_FUNCTIONS_ROLE: (id) => API_DOMAIN + `roles/${id}/functions`,
    GET_FUNCTIONS_ASSIGNABLE: ({ id, page, size, status, search }) => API_DOMAIN + `roles/${id}/assignable-functions?page=${page}&size=${size}&status=${status}&s=${search}`
  },
  USERS: {
    GET_USER_BY_EMAIL: API_DOMAIN + 'get-user-by-email?email=',
    DELETE: API_DOMAIN + 'delete-account'
  },
  USER_ROLE: {
    GET_USER_ROLE_LIST: (targetUserId) => API_DOMAIN + `users/${targetUserId}/roles/list`,
    GET_ASSIGNABLE_ROLES: (targetUserId) => API_DOMAIN + `users/${targetUserId}/assignable-roles`,
    UPDATE_ASSIGN_ROLES: (targetUserId) => API_DOMAIN + `users/${targetUserId}/roles/update-assign`,
    ASSIGN_ROLE: (targetUserId) => API_DOMAIN + `users/${targetUserId}/roles/assign`,
    UNASSIGN_ROLE: (targetUserId, roleId) => API_DOMAIN + `users/${targetUserId}/roles/unassign/${roleId}`,
    GET_ROLE_SCOPES: (targetUserId, roleId) => API_DOMAIN + `users/${targetUserId}/roles/${roleId}/scopes`,
    UPDATE_ROLE_SCOPE: (targetUserId) => API_DOMAIN + `users/${targetUserId}/role-scopes/update`,
    DELETE_ROLE_SCOPES: (targetUserId) => API_DOMAIN + `users/${targetUserId}/role-scopes/delete`
  },
  POSITION: {
    GET: API_DOMAIN + 'unit/v1.0/positions/list',
    GET_AVAIBALE: (id) => API_DOMAIN + `unit/v1.0/${id}/positions/available`,
    ADD: API_DOMAIN + 'unit/v1.0/positions/add',
    UPDATE: API_DOMAIN + 'unit/v1.0/positions/update',
    DELETE: (id) => API_DOMAIN + `unit/v1.0/positions/delete/${id}`
  },
  FUNCTION: {
    GET_FUNCTION_SCOPE: (functionCode) => API_DOMAIN + `functions/${functionCode}/scope`
  },
  HISTORY: {
    UPDATE_2FA: API_DOMAIN + 'history/update-2fa',
    UPDATE_DETAIL_2FA: (userId) => API_DOMAIN + `history/update-2fa/${userId}`,
  },
  MONITOR: {
    GET: API_DOMAIN + 'v1.1/rooms/monitor/list',
    ENDPOINT_STATS: API_DOMAIN + 'endpoint-stats',
  }
};

export default API_MAP;

export { DOMAIN_MEETING, API_DOMAIN, SOCKET_URL, MOBILE_BUILD_VERSION, PATH_ROOT };
